import styled from 'styled-components';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Container = styled.div<SizeProps>`
  display: flex;
  flex-direction: column;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
`;

export const BlueHeader = styled.div`
  width: 100%;
  height: 189px;
  background-color: #ebebeb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 24px;
  gap: 12px;
`;

export const SearchBox = styled.div`
  max-width: 450px;
  width: 100%;
  margin: -24px auto 0;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 10px 24px 0px rgba(0, 0, 0, 0.1);
  padding: 24px;
`;

export const Section = styled.div`
  max-width: 450px;
  width: 100%;
  margin: 24px auto 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TicketCardRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
`;

export const CategoryRow = styled.div`
  padding: 14px 0;
  border-bottom: 1px solid #f5f5f5;
`;
